import Reflux from "reflux";
export const getAETitle = Reflux.createAction();
export const setAETitle = Reflux.createAction();
